import { Column } from 'material-table';
import React from 'react';
import { CategoryModelFullDto } from '../../../Models/CategoryModelFullDto';
import { ClassificationModel } from '../../../Models/ClassificationModel';
import { BatchCorrectionSearchType } from './enum/BatchCorrectionSearchType';

export interface IBatchCorrectionContextProps {
    filterColumnsDialogOpen: boolean,
    setFilterColumnsDialogOpen: (open: boolean) => void,
    searchType: BatchCorrectionSearchType | null,
    setSearchType: (search: BatchCorrectionSearchType | null) => void,
    tableColumns: Column<ClassificationModel | CategoryModelFullDto>[],
    setTableColumns: (column: Column<ClassificationModel | CategoryModelFullDto>[]) => void,
    callSearch: boolean,
    setCallSearch: (call: boolean) => void
}

export const batchCorrectionContextInitial: IBatchCorrectionContextProps = {
    filterColumnsDialogOpen: false,
    setFilterColumnsDialogOpen: () => { ''; },
    searchType: null,
    setSearchType: () => { ''; },
    tableColumns: [],
    setTableColumns: () => { ''; },
    callSearch: false,
    setCallSearch: () => { ''; },
};

export const BatchCorrectionContext = React.createContext(batchCorrectionContextInitial);